module.exports = __webpack_public_path__ + "img/priceintro.a2beaa95.png";